export default __webpack_public_path__ + "static/media/logo.4a2cacf4.png";